import { jsx as _jsx } from "react/jsx-runtime";
function Pause({ className, size = 24 }) {
    return (_jsx("svg", { className: className, height: size, width: size, fill: "currentColor", viewBox: "0 0 16 16", children: _jsx("path", { d: "M5,3C5,2.734 5.105,2.481 5.293,2.293C5.481,2.105 5.734,2 6,2C6.266,2 6.519,2.105 6.707,2.293L11.707,7.293C12.097,7.683 12.097,8.317 11.707,8.707L6.707,13.707C6.519,13.895 6.266,14 6,14C5.734,14 5.481,13.895 5.293,13.707C5.105,13.519 5,13.266 5,13L5,3Z" }) }));
}
export default Pause;
